import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';

import styles from './Spinner.module.css';

const Spinner = ({ size = "large" }) => {
  return (
    <div className={size === 'large' ? styles['spinner-large'] : styles.spinner}>
      <Spin size={size} />
    </div>
  );
};

Spinner.propTypes = {
  size: PropTypes.string
};

export default Spinner;
